import { createVNode as e, mergeProps as s } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/StatisticsFilledStandard.js";
import d from "../components/PfIcon.js";
const t = (r, a) => {
  const i = {
    ...r,
    ...a.attrs
  };
  return e(d, s(i, {
    icon: o
  }), null);
};
t.displayName = "StatisticsFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
